<template>
  <div class="md:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-20">
    <button
      type="button"
      class="bg-primary-dark text-white px-6 py-3 rounded-full shadow-lg font-bold flex items-center gap-2"
      @click="$emit('toggle')"
    >
      <i :class="activeView === 'list' ? 'ph ph-map-trifold' : 'ph ph-list-dashes'" class="text-lg"></i>
      {{ activeView === 'list' ? labels.show_map : labels.show_list }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  activeView: { type: String, required: true }, // 'list' | 'map'
  labels: { type: Object, required: true },
});

defineEmits(['toggle']);
</script>
